var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 431,
    viewBox: "0 0 585 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.325 240.946C575.531 211.219 602.672 135.882 572.945 72.6756C543.219 9.46937 467.882 -17.6714 404.676 12.0556C341.469 41.7818 314.329 117.119 344.055 180.326C373.782 243.532 449.119 270.672 512.325 240.946Z",
    fill: "url(#paint0_radial_170_433)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.861 46.5837C253.473 21.1016 358.935 85.2493 384.417 189.861C409.898 294.473 345.751 399.935 241.139 425.416C136.527 450.898 31.0654 386.751 5.58358 282.139C-19.8982 177.527 44.2494 72.0657 148.861 46.5837Z",
    fill: "url(#paint1_radial_170_433)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_170_433",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(458.503 126.5) rotate(-25.1881) scale(126.471 126.471)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#A5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#A4DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#D23681",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0113AB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_170_433",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.9257 313.079) rotate(-31.7154) scale(353.016 323.447)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827187,
    stopColor: "#390B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D374D5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBg);
export default __webpack_public_path__ + "static/media/aboutBg.0a74398b77e0ff2dc3e742e2085f4b9b.svg";
export { ForwardRef as ReactComponent };